import { createFileRoute } from '@tanstack/react-router'

import { PassCardBind } from '@/pages/pass-card-bind'

export const Route = createFileRoute('/_protected/pass-card-bind/')({
    component: () => <PassCardBind />,
    validateSearch: (search) => {
        return {
            tx: search.tx ? String(search.tx) : undefined,
        }
    },
})
